import React from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import PanelLayout from "layouts/PanelLayout";
import "styles/student.css";

export const StudentTestInfoPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const subject = location.state?.subject;
  const type = location.state?.type;

  const tests = {
    1: {
      title: "Qisqa ko‘paytirish formulalari",
      attempts: 5,
      used: 2,
      q: 12,
      date: "20.09.2025",
      result: 8,
      author: "Asrorov J.",
    },
    2: {
      title: "Tenglamalar testlari",
      attempts: 4,
      used: 1,
      q: 10,
      date: "11.09.2025",
      result: 7,
      author: "Qodirov M.",
    },
    3: {
      title: "Trigonometriya asoslari",
      attempts: 6,
      used: 3,
      q: 15,
      date: "05.10.2025",
      result: 10,
      author: "Aliyeva N.",
    },
  };

  const test = tests[id];

  return (
    <PanelLayout>
      <div className="info-container">
        <div className="badge-group">
          <p className="badge">{type}</p>
        </div>

        <div className="info-card">
          <div className="info-row">
            Urinishlar soni: <b>{test.attempts}</b>
          </div>

          <div className="info-row">
            Nechta uringan: <b>{test.used}</b>
          </div>

          <div className="info-row">
            Savollar soni: <b>{test.q}</b>
          </div>

          <div className="info-row">
            Yaratilgan vaqti: <b>{test.date}</b>
          </div>

          <div className="info-row">
            Oxirgi natija: <b>{test.result}</b>
          </div>
        </div>

        <div className="creator-info">
          <div className="creator-box">
            <img
              src={"https://i.pravatar.cc/150?img=3"}
              alt="creator"
              className="creator-avatar"
            />
            <div className="creator-details">
              <span className="creator-name">Nodir Akhmedov</span>
              <span className="creator-subName">Tuzuvchi</span>
            </div>
          </div>
          <button
            type="button"
            className="save-btn big-finish"
            onClick={() => navigate("/student/test/start", { state: { test } })}
          >
            Boshlash
          </button>
        </div>
      </div>
    </PanelLayout>
  );
};
